import { render, staticRenderFns } from "./ProductReport.vue?vue&type=template&id=5e89c104&scoped=true&"
import script from "./ProductReport.vue?vue&type=script&lang=js&"
export * from "./ProductReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductReport.vue?vue&type=style&index=0&id=5e89c104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e89c104",
  null
  
)

export default component.exports